import { EnumObj } from "./EnumObj";

export const EStatusEtapaFluxoProcesso = {
  Preenchendo: new EnumObj("bf3afbd8-0e19-4474-894a-a48f35e5b546", 'Preenchendo', 1),
  Concluido: new EnumObj("91f72c3e-806e-437e-a903-726397d17dc9", 'Concluído', 2),
  Pendente: new EnumObj("3598e65b-b88d-4ead-910c-add169af5d5d", 'Preenchendo', 3),
  NaoAplicavel: new EnumObj("6b26ff9f-9512-44aa-9c71-2be6d46cff53", 'Não Aplicável', 4),
  Obrigatorio: new EnumObj("a0837261-e4f9-46d6-968c-d0d9d5e84ce1", 'Obrigatório', 5),
}

export const getEStatusEtapaFluxoProcessoById = (id: string): EnumObj | undefined => {
  var arryTipos = Object.values(EStatusEtapaFluxoProcesso);
  return arryTipos.find(t => t.id == id);
};